module.exports = __webpack_public_path__ + "static/media/intro.0e018077.png";